import React from 'react';
import { PropInfo, CodeExample, RadioProps, RadioGroupProps } from '@cimpress/react-components';

import RadioCode from '!raw-loader!./radio.jsx';
import RadioDemo from './radio.jsx';
import RadioInlineCode from '!raw-loader!./radioinline.jsx';
import RadioInlineDemo from './radioinline.jsx';
import ComponentDoc from '../../shared/TabbedComponentDoc';

const RadioDocs = () => {
  const radioGroupPropInfos: PropInfo<RadioGroupProps>[] = [
    {
      name: 'inline',
      type: 'boolean',
      default: 'false',
      description:
        'If true, radio options will display in a row instead of stacked.  If there is not enough width for all options, radios will wrap.',
    },
    {
      name: 'children',
      type: 'node',
      default: '',
      description: (
        <div>
          Pass <code>&lt;Radio /&gt;</code> elements as children to the radio group.
        </div>
      ),
    },
    {
      name: 'defaultSelected',
      type: 'any',
      default: '',
      description:
        'The default radio group selection. If no default is defined, no radio button will be initially selected.',
    },
    {
      name: 'valueSelected',
      type: 'any',
      default: '',
      description: 'The current selected value of the radio group.',
    },
    {
      name: 'onChange',
      type: 'function',
      default: '',
      description: (
        <div>
          <p>Callback function that is fired when the selected radio button changes. </p>
          <p>
            Signature: <code>function(event: object, value: undefined) {'=>'} void</code>{' '}
          </p>
          <p>
            <code>event:</code> Change event targeting the radio button.
          </p>
          <p>
            <code>value:</code> Value of the selected radio button{' '}
          </p>
        </div>
      ),
    },
  ];
  const propInfos: PropInfo<RadioProps>[] = [
    {
      name: 'name',
      type: 'string',
      default: '',
      description: 'Name to apply to the child radio buttons.',
    },

    {
      name: 'className',
      type: 'string',
      default: '',
      description: 'Additional classNames to be appended to the parent container of the radio buttons',
    },
    {
      name: 'label',
      type: 'string or node',
      default: '',
      description: 'Label for the radio button.',
    },
    {
      name: 'id',
      type: 'string',
      default: '',
      description: 'ID prop for the input field',
    },
    {
      name: 'value',
      type: 'any',
      default: '',
      description: 'Value of the radio button',
    },
    {
      name: 'disabled',
      type: 'boolean',
      default: 'false',
      description: 'Marks the radio button as disabled',
    },
    {
      name: 'className',
      type: 'string',
      default: '',
      description: 'Additional classNames to be appended to the parent element of the input field',
    },
  ];

  return (
    <div>
      <ComponentDoc name="Radio Group" propInfos={radioGroupPropInfos} />
      <ComponentDoc name="Radio" propInfos={propInfos}>
        <RadioDemo />
        <CodeExample code={RadioCode} />
        <RadioInlineDemo />
        <CodeExample code={RadioInlineCode} />
      </ComponentDoc>
    </div>
  );
};

export default RadioDocs;
